import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit, OnDestroy {
  private intervalId: any;
  private glitchInterval: any;

  constructor(private router: Router) {}

  ngOnInit() {
    // Make robot react on hover
    const robot = document.querySelector('.robot');
    if (robot) {
      robot.addEventListener('mouseenter', this.robotReact);
      robot.addEventListener('mouseleave', this.robotNormal);
    }

    // Add random data streams
    this.intervalId = setInterval(() => {
      if (Math.random() > 0.6) {
        this.createDataStream();
      }
    }, 1500);

    // Glitch effect on error code
    this.glitchInterval = setInterval(() => {
      this.glitchEffect();
    }, 5000);
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    if (this.glitchInterval) {
      clearInterval(this.glitchInterval);
    }
    const robot = document.querySelector('.robot');
    if (robot) {
      robot.removeEventListener('mouseenter', this.robotReact);
      robot.removeEventListener('mouseleave', this.robotNormal);
    }
  }

  goHome() {
    this.router.navigate(['/']);
  }

  goBack() {
    window.history.back();
  }

  private robotReact(event: any) {
    const element = event.target;
    element.textContent = '🤯';
    element.classList.add('shake');
  }

  private robotNormal(event: any) {
    const element = event.target;
    setTimeout(() => {
      element.textContent = '🤖';
      element.classList.remove('shake');
    }, 500);
  }

  private createDataStream() {
    const stream = document.createElement('div');
    stream.className = 'data-stream-particle';
    stream.style.left = Math.random() * 100 + '%';
    stream.style.animationDuration = (2 + Math.random() * 2) + 's';
    stream.textContent = Math.random() > 0.5 ? '01' : '10';
    const circuitBg = document.querySelector('.circuit-bg');
    if (circuitBg) {
      circuitBg.appendChild(stream);
      setTimeout(() => {
        stream.remove();
      }, 4000);
    }
  }

  private glitchEffect() {
    const digits = document.querySelectorAll('.digit');
    digits.forEach((digit, index) => {
      setTimeout(() => {
        digit.classList.add('glitch');
        setTimeout(() => {
          digit.classList.remove('glitch');
        }, 200);
      }, index * 100);
    });
  }
}